<template>
  <div>

    <v-modal name="message">
      <template v-slot:content="{message, title, type, buttonText, callBack}">
        <ModalMessage :message="message"
                      :title="title"
                      :type="type"
                      :buttonText="buttonText"
                      :callBack="callBack"
        />
      </template>
    </v-modal>

    <v-modal name="auth-login" :title="$t('Вхід')">
      <template v-slot="{redirect}">
        <AuthLogin :redirect="redirect"/>
      </template>
    </v-modal>

    <v-modal name="auth-registration" :title="$t('Реєстрація')">
      <template v-slot="{redirect}">
        <AuthRegistration :redirect="redirect"/>
      </template>
    </v-modal>

    <v-modal name="auth-reset-password" :title="$t('Змінити пароль')">
      <template v-slot="{}">
        <AuthResetPassword/>
      </template>
    </v-modal>

    <v-modal name="subscribe" :title="$t('Приєднатися до нас')">
      <template v-slot="{}">
        <Subscribe/>
      </template>
    </v-modal>

    <v-modal name="map" :title="$t('Адреса')">
      <template v-slot="{}">
        <GoogleMap/>
      </template>
    </v-modal>

    <v-modal name="select-place" :title="$t('Оберіть заклад')">
      <template v-slot="{}">
        <SelectPlace/>
      </template>
    </v-modal>

  </div>
</template>

<script>
import ModalMessage from './ModalMessage'
import AuthLogin from './AuthLogin'
import AuthRegistration from './AuthRegistration'
import AuthResetPassword from './AuthResetPassword'
import GoogleMap from './GoogleMap'
import Subscribe from './Subscribe'
import SelectPlace from '@/components/SelectPlace'

export default {
  components: {
    SelectPlace,
    Subscribe,
    GoogleMap,
    ModalMessage,
    AuthLogin,
    AuthRegistration,
    AuthResetPassword
  },
  data() {
    return {}
  }
}
</script>

<style lang="less">

</style>
